/* @flow */

export default class AddNewCompanyRequest {
  companyType: number;
  insurerId: string;
  functionName: string;    
  mobile: string;
}
